import { JourneyProgramLabel } from '../../types/models/product/journey'

/**
 * The options the students of the selected programmes can book. An activity can be linked to one
 * of them: the backend then only counts the students who booked it.
 */
export const getActivityBookableOptions = (
  journeys: JourneyProgramLabel[],
  journeyIds: number[] = []
) => {
  const options = journeys
    .filter((journey) => journeyIds.includes(journey.id))
    .flatMap((journey) => journey.secondaryOptions.map(({ option }) => option))

  return options.filter(
    (option, index) => options.findIndex((other) => other.id === option.id) === index
  )
}
